import { PageLayout } from "@src/common/PageLayout";
import { styled } from "@uhg-abyss/web/tools/styled";
import { Heading } from "@uhg-abyss/web/ui/Heading";
import { Router } from "@uhg-abyss/web/ui/Router";
import { Fragment } from "react";

const Container = styled("div", {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "300px",
  height: "100%",
  width: "100%",
  backgroundColor: "$app.color.surface.container.secondary",
});

const ZeroPaddingPageLayout = styled(PageLayout, {
  padding: "0",
});

export const HealthCheck = () => {
  return (
    <Fragment>
      <ZeroPaddingPageLayout backgroundColor={"$app.color.surface.container.secondary"}>
        <Router.MetaTags title="Health Check" />
        <Container>
          <Heading size="md" style={{ fontWeight: 600 }}>
            Status: OK
          </Heading>
        </Container>
      </ZeroPaddingPageLayout>
    </Fragment>
  );
};
